// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border-radius-5[data-v-208ac29a]{border-radius:5px!important}.text-dark-grey[data-v-208ac29a]{color:#656e81!important}.outlined-border[data-v-208ac29a]{background-color:#fff;border:.6px solid #d9dde3}.outlined-hover[data-v-208ac29a]:hover{background:#fff;box-shadow:0 2px 6px rgba(0,0,0,.161)}.outlined-hover[data-v-208ac29a]:hover,.plain-hover[data-v-208ac29a]:hover{color:#004adb!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
